module.exports = __webpack_public_path__ + "img/banner-en.14c58d02.png";